import { render } from "./BankVib.vue?vue&type=template&id=9280bf2a"
import script from "./BankVib.vue?vue&type=script&lang=js"
export * from "./BankVib.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__